export class Data {
    constructor(public data: Object) {}
}


// WEBPACK FOOTER //
// D:/Venkat Projects/sagiam-tool-angular/src/app/data.model.ts